
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.125 5.625h-1.02c.243-.473.395-.996.395-1.563A3.443 3.443 0 0014.062.626c-1.624 0-2.675.832-4.023 2.668C8.691 1.457 7.641.625 6.016.625a3.443 3.443 0 00-3.438 3.438c0 .566.149 1.09.395 1.562H1.875C.84 5.625 0 6.465 0 7.5v5c0 .344.281.625.625.625h.625v4.195c0 1.133.922 2.055 2.055 2.055h13.39a2.057 2.057 0 002.055-2.055v-4.195h.625A.627.627 0 0020 12.5v-5c0-1.035-.84-1.875-1.875-1.875zM9.062 17.5H3.306a.18.18 0 01-.18-.18v-4.195H7.5V11.25H1.875V7.5h7.188v10zM6.013 5.625a1.562 1.562 0 110-3.125c.86 0 1.465.297 3.285 3.008l.078.117H6.012zm4.765-.117c1.82-2.711 2.426-3.008 3.286-3.008a1.562 1.562 0 110 3.125h-3.364l.078-.117zm7.348 5.742H12.5v1.875h4.375v4.195a.18.18 0 01-.18.18h-5.758v-10h7.188v3.75z","fill":"#0B0E1F"}})])
          )
        }
      }
    